// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2v3LX","col":"Table_col__17Eo9","fulfillmentStatus":"Table_fulfillmentStatus__2KwSL","emailCol":"Table_emailCol__2YLkG"};